import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { APP_DESTINATIONS, getFrontendUrl } from "shared";
import { useDossier } from "shared/welda/features/dossier/context/DossierContext";

function ErrorBoundaryPage({
  error = undefined,
  resetErrorBoundary = undefined,
}) {
  const { t } = useTranslation();
  const { dossier = {} } = useDossier();
  const dossierNr = dossier?.number ?? null;
  const frontendUrl = dossierNr
    ? getFrontendUrl({
        dossierNr,
        destination: APP_DESTINATIONS.SITE.KEY,
      })
    : null;

  // Handle other errors
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
          {t("frontend.common.something-went-wrong.text")}
        </p>
        <hr />
        <button
          className="btn btn-primary btn-sm mt-3"
          onClick={() => (window.location.href = frontendUrl)}
        >
          <FontAwesomeIcon icon={faHome} className="me-2" />
          {t("frontend.error.take-me-home.text")}
        </button>
      </Card.Body>
    </Card>
  );
}

export default ErrorBoundaryPage;
